export { default as LandingContent } from './LandingContent';